<template>
    <div style="position: relative;">
        <tree ref="menuTree" style="min-height:50vh"
              :data="menuList"
              node-icon="nodeIcon"
              :width="width"
              :nodeKey="nodeKey"
              :expandedKeys="expandedKeys"
              :treeConfig="treeConfig"
              @selTree="selTree"
              v-loading="loading"></tree>
    </div>
</template>

<script>
    import tree from "./tree"

    export default {
        name: "deptTree",
        components: {
            tree
        },
        props: ['width'],
        data() {
            return {
                menuList: [],
                treeConfig: {
                    children: 'children',
                    label: 'name',
                },
                nodeKey: 'id',
                expandedKeys: ["0"],
                loading: false,
            }
        },
        created() {
            this.initTree();
        },
        methods: {
            async initTree() {
                await this.getListData();
                this.getKeys(this.menuList, this.expandedKeys);
            },
            getKeys(data, arr) {
                if (data && data.length > 0) {
                    if (data[0].children && data[0].children.length > 0) {
                        arr.push(data[0].id);
                        this.getKeys(data[0].children, arr);
                    }
                }
            },
            //通过id获取节点数据
            getData(arr, key) {
                if (key) {
                    let ret;
                    arr.map(item => {
                        if (item.id === key) {
                            this.expandedKeys.push(item.id);
                            ret = item;
                        } else {
                            if (item.children && item.children.length > 0) {
                                let child_ret = this.getData(item.children, key);
                                if (child_ret) {
                                    this.expandedKeys.push(item.id);
                                    ret = child_ret;
                                }
                            }
                        }
                    })
                    if (ret)
                        return ret;
                }
            },
            async refreshTree(key) {
                if (!key) {
                    this.initTree();
                    return
                }
                this.expandedKeys = [];
                await this.getListData();

                this.$refs["menuTree"].setkey(key);
                if (key)
                    key = parseInt(key);
                let ret = this.getData(this.menuList, key);
                this.$emit('selTree', ret);
            },
            async getListData() {
                this.loading = true;

                let param = {
                    url:"/department/listZTree",
                    param:{
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                const retData = data.data.jsonStr;
                this.menuList =retData;
                if(retData){
                    this.menuList = [{
                        id:"0",
                        name:"组织机构",
                        children:retData,
                    }]
                }

                this.loading = false;
            },
            selTree(data) {
                this.$emit('selTree', data);
            },
        }
    }

</script>

<style lang="scss">

</style>
